var _title, _desc, _defs, _g, _path, _ellipse, _rect, _rect2, _g2, _g3;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgErrorPage = function SvgErrorPage(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "505px",
    height: "367px",
    viewBox: "0 0 505 367",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Group 2")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M64,24 C86.5693582,37.3599356 115.974824,44.0399034 152.216398,44.0399034 C206.578758,44.0399034 283.799927,58.0546224 249.26108,104.267902 C214.722233,150.481182 104.994652,152.723967 123.853112,197.63915 C149.069977,257.698142 395.326245,135.899445 421.420954,183.82563",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-1.8%",
    y: "-4.2%",
    width: "107.1%",
    height: "113.3%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "dilate",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 9,
    dy: 9,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "shadowInner"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 9,
    dy: 9,
    in: "shadowInner",
    result: "shadowInner"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetOuter1",
    in2: "shadowInner",
    operator: "out",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.1 0",
    type: "matrix",
    in: "shadowOffsetOuter1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "74.036124%",
    y1: "76.1100438%",
    x2: "14.0391482%",
    y2: "37.9943903%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "path-4",
    x: 0,
    y: 0,
    width: 91.8507463,
    height: 134.025126,
    rx: 10
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-9.3%",
    y: "-6.3%",
    width: "127.2%",
    height: "118.7%",
    filterUnits: "objectBoundingBox",
    id: "filter-5"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.170006793 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Error-Screens",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Something-went-wrong",
    transform: "translate(-515.000000, -153.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(420.000000, 120.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(98.001769, 36.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Code",
    transform: "translate(359.681709, 247.696976) rotate(9.000000) translate(-359.681709, -247.696976) translate(148.681709, 140.196976)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-3",
    fill: "#D8D8D8",
    style: {
      mixBlendMode: "darken"
    },
    transform: "translate(37.393264, 50.122961) rotate(-10.000000) translate(-37.393264, -50.122961) ",
    cx: 37.3932636,
    cy: 50.1229608,
    rx: 25,
    ry: 4.5
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Path-2"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#00C48C",
    strokeWidth: 8,
    xlinkHref: "#path-1"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.8907146,0 C49.627307,0 57.9808903,6.17333896 61.5467969,14.9704698 L67,16.3946644 C68.3169178,19.0723013 68.9753767,21.627238 68.9753767,24.0594744 C68.9753767,26.4917108 68.3169178,28.9145856 67,31.3280988 L61.8764993,33.1710188 C58.5178385,42.4223817 49.9410664,49 39.8907146,49 C36.343308,49 31.6205023,49.0160048 25.7222974,49.0480144 L25.7222974,49.0480144 L25,0 L25,0 Z",
    id: "Combined-Shape",
    fill: "#196AE5"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-2",
    fill: "#C5DAF8",
    cx: 25.5,
    cy: 24.5,
    rx: 10.5,
    ry: 24.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-6",
    fill: "#0041B2",
    x: 1.8189894e-12,
    y: 13,
    width: 28,
    height: 7,
    rx: 3.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-6-Copy",
    fill: "#0041B2",
    x: 1.8189894e-12,
    y: 29,
    width: 28,
    height: 7,
    rx: 3.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Base"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path-3",
    fillOpacity: 0.07,
    fill: "url(#linearGradient-3)",
    style: {
      mixBlendMode: "multiply"
    },
    points: "6.92553548 133.693926 89.3525397 2.94639076 180.323732 68.3201581 180.323732 178.87299 73.4054251 178.87299"
  }), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Shadow"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-5)",
    xlinkHref: "#path-4"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#302C48",
    fillRule: "evenodd",
    xlinkHref: "#path-4"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Plug",
    transform: "translate(17.000000, 38.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.3289508,10.6662206 C56.3877364,15.8577465 58.6318408,22.2499502 58.6318408,28.9824121 C58.6318408,35.7149773 56.3876672,42.1072727 52.3287675,47.298838 L52.3283582,53.4648241 C52.3283582,56.5023902 49.8659243,58.9648241 46.8283582,58.9648241 L11.7039801,58.9648241 C8.66641398,58.9648241 6.2039801,56.5023902 6.20398013,53.4650543 L6.20281336,48.3952164 C1.58640078,43.034732 -1,36.2078562 -1,28.9824121 C-1,21.7569679 1.58640078,14.9300921 6.20281336,9.56960775 L6.2039801,4.5 C6.2039801,1.46243388 8.66641398,-1 11.7039801,-1 L46.8283582,-1 C49.8659243,-1 52.3283582,1.46243388 52.3283582,4.49990389 L52.3289508,10.6662206 Z",
    id: "Combined-Shape",
    strokeOpacity: 0.398494112,
    stroke: "#000000",
    strokeWidth: 2,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-3",
    fill: "#302C48",
    x: 18.119403,
    y: 17.7688442,
    width: 6.30348259,
    height: 22.4874372,
    rx: 3.15174129
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-3-Copy",
    fill: "#302C48",
    x: 33.4278607,
    y: 17.7688442,
    width: 6.30348259,
    height: 22.4874372,
    rx: 3.15174129
  }))))))))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgErrorPage, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/errorPage.b4974c82.svg";
export { ForwardRef as ReactComponent };